import { render } from "./ContentBuilderSidebar.vue?vue&type=template&id=edf9f872"
import script from "./ContentBuilderSidebar.vue?vue&type=script&lang=js"
export * from "./ContentBuilderSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__